import { Outlet, Link } from "react-router-dom";
import React, { useState, useEffect, createContext } from "react";
import "../css/admin.css";

import SocketContext from "./socket-context";

// const Layout = () => {
const UsersMsgs = ({socket}) => {
    const [roomUsers, setRoomUsers] = useState([]);
    const [messagesRecieved, setMessagesReceived] = useState([]);

    useEffect(() => {
      socket.on('chatroom_users', (data) => {
        console.log('chatroom_users are---', data);
        setRoomUsers(data);
      });
  
      return () => socket.off('chatroom_users');
    }, [socket]);

    useEffect(() => {
        socket.on('receive_message', (data) => {
          console.log("receive_message-->>", data);
          setMessagesReceived((state) => [
            ...state,
            {
              message: data.message,
              username: data.username,
              __createdtime__: data.__createdtime__,
            },
          ]);
        });
    
        // Remove event listener on component unmount
        return () => socket.off('receive_message');

    }, [socket]);

    useEffect(() => {
      // Last 100 messages sent in the chat room (fetched from the db in backend)
      socket.on('last_100_messages', (last100Messages) => {
        console.log('Last 100 messages:', last100Messages);
        // console.log('Last 100 messages:', JSON.parse(last100Messages));
        // last100Messages = JSON.parse(last100Messages);
        // last100Messages = sortMessagesByDate(last100Messages);
        setMessagesReceived((state) => [...last100Messages, ...state]);
      });

      return () => socket.off('last_100_messages');
    }, [socket]);

    function sortMessagesByDate(messages) {
      return messages.sort(
        (a, b) => parseInt(a.__createdtime__) - parseInt(b.__createdtime__)
      );
    }

    // useEffect(() => {
    //     const userData = JSON.parse(localStorage.getItem("user-data"));
    //     setUser(userData[0].firstName);
    //     setShowContent(true);
    // }, []);

    // const toggleMenu = () => {
    //     setOpenMenu(!openMenu);
    // };

    return (
        <SocketContext.Provider value={{roomUsers:roomUsers, messagesRecieved:messagesRecieved, setMessagesReceived:setMessagesReceived}}>
            <Outlet />
        </SocketContext.Provider>
    )
};

export default UsersMsgs;